export default __webpack_public_path__ + "e6eed45a03c27ecb8dd3909f327f0767.png";